import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */
const { Types, Creators } = createActions({
  requestConfig: [],
  setConfig: ['config'],
  setProductError: ['error'],
});
export const ProductTypes = Types;
export default Creators;

/* Initial State */
export const INITIAL_STATE_OBJ = {
  product: null,
  theme: null,
  colors: {
    primary: '#000000',
    positive: '#00C268',
    warning: '#F4B511',
    negative: '#F93434',
  },
  logo: '',
  favicon: '',
  trainingsLabel: '',
  myTrainingsLabel: '',
  progressLabel: '',
  hasProductFilter: true,
  productSearchPlaceholder: null,
  emptyListText: null,
  loadedConfigs: false,
  showWelcomeMessage: false,
  loginRegisterText: '',
  loginRegisterLink: '',
  initialPage: 'DASHBOARD',
  productName: '',
  helpLink: null,
  helpTitle: null,
  helpInNewTab: false,
  supportEmail: null,
  scriptJs: null,
  error: false,
  showAppointments: false,
};
const INITIAL_STATE = Immutable(INITIAL_STATE_OBJ);

/* Reducers */
const setConfig = (state = INITIAL_STATE, { config }) => ({
  ...state,
  product: config.product,
  theme: config.theme,
  colors: {
    primary: config.primaryColor,
    positive: config.successColor,
    warning: config.warningColor,
    negative: config.errorColor,
  },
  logo: config.logo,
  favicon: config.favicon,
  trainingsLabel: config.trainingsLabel
    ? config.trainingsLabel
    : 'Treinamentos',
  myTrainingsLabel: config.myTrainingsLabel
    ? config.myTrainingsLabel
    : 'Meus treinamentos',
  progressLabel: config.progressLabel ? config.progressLabel : 'Progresso',
  hasProductFilter: config.hasProductFilter,
  productSearchPlaceholder: config.productSearchPlaceholder,
  emptyListText: config.emptyListText,
  loadedConfigs: true,
  showWelcomeMessage: config.showWelcomeMessage,
  loginRegisterText: config.loginRegisterText,
  loginRegisterLink: config.loginRegisterLink,
  initialPage: config.studentInitialPage,
  productName: config.productName,
  helpLink: config.help,
  helpTitle: config.helpTitle,
  helpInNewTab: config.newTab,
  supportEmail: config.supportEmail,
  scriptJs: config.scriptJs,
  error: false,
  showAppointments: config.showConsultancy,
});

const setProductError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error,
});

/* Reducers to types */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_CONFIG]: setConfig,
  [Types.SET_PRODUCT_ERROR]: setProductError,
});
